import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useGetProductsQuery } from '../../Store/api/apiSlice';
import Products from '../Products/Products';
import styles from '../../styles/Search.module.scss';

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const query = searchParams.get('q') || '';

  const { data: products = [], isLoading, isError } = useGetProductsQuery({ search: query }, { skip: !query });

  useEffect(() => {
    // SEO мета-теги для страницы поиска
    if (query) {
      document.title = `Результати пошуку: ${query} - Інтернет-магазин`;
      
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', `Результати пошуку за запитом "${query}"`);
    } else {
      document.title = 'Пошук - Інтернет-магазин';
    }

    return () => {
      document.title = 'Інтернет-магазин';
    };
  }, [query]);

  if (!query) {
    return (
      <section className={styles.searchResults}>
        <div className={styles.empty}>
          <h2>Введіть пошуковий запит</h2>
          <p>Використовуйте поле пошуку в шапці сайту для пошуку товарів</p>
        </div>
      </section>
    );
  }

  if (isLoading) {
    return (
      <section className={styles.searchResults}>
        <div className={styles.loading}>Завантаження результатів пошуку...</div>
      </section>
    );
  }

  if (isError) {
    return (
      <section className={styles.searchResults}>
        <div className={styles.error}>Помилка при виконанні пошуку</div>
      </section>
    );
  }

  return (
    <section className={styles.searchResults}>
      <div className={styles.header}>
        <h2>Результати пошуку</h2>
        <p className={styles.query}>
          За запитом: <strong>"{query}"</strong>
        </p>
        <p className={styles.count}>
          Знайдено товарів: <strong>{products.length}</strong>
        </p>
      </div>

      {products.length === 0 ? (
        <div className={styles.empty}>
          <h3>Нічого не знайдено</h3>
          <p>Спробуйте змінити пошуковий запит або використати інші ключові слова</p>
          <button 
            className={styles.backButton}
            onClick={() => navigate('/')}
          >
            Повернутися на головну
          </button>
        </div>
      ) : (
        <Products products={products} title="" amount={products.length} />
      )}
    </section>
  );
};

export default SearchResults;

